import {onCLS, onFID, onLCP, onFCP, onTTFB, onINP} from 'web-vitals'
import {setTrack} from "./utils";

const metrics = {}
let sent = false

const sendToMixpanel = () => {
  if (sent) return

  const required = ['LCP']
  const allReady = required.every(key => metrics[key] !== undefined)

  if (!allReady) return

  sent = true

  setTrack('pagespeed', {metrics})
}

// Засекаем начало (в index.html вставь <script>window.__appStartTime = performance.now()</script>)
function onLoad(callback) {
  if (document.readyState === 'complete')
    requestAnimationFrame(() => callback())
  else
    window.addEventListener('load', callback)
}
onLoad(() => {
  // metrics.load_time_ms = Math.round(performance.now() - (window.__appStartTime || 0))
  // sendToMixpanel()

  const value = Math.round(performance.now() - (window.__appStartTime || 0))
  setTrack('load_time', {value})
})

// Подключаем web-vitals
const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    onCLS(onPerfEntry)
    onFID(onPerfEntry)
    onLCP(onPerfEntry)
    onFCP(onPerfEntry)
    onTTFB(onPerfEntry)
    onINP(onPerfEntry)
  }
}
reportWebVitals(({name, value}) => {
  metrics[name] =
    name === 'CLS'
      ? +value.toFixed(3)
      : Math.round(value)

  sendToMixpanel()
})

// window.addEventListener('pointerdown', sendToMixpanel, {once: true})
// window.addEventListener('keydown', sendToMixpanel, {once: true})